/* CloudHelden: markiert in Prüfungstermin-Tabellen (.clh-termine) je Zeile den nächsten Termin
   und aktualisiert Textstellen mit data-clh-next="<Zeilen-ID>". */
(function () {
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var fmt = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
  document.querySelectorAll('.clh-termine tbody tr').forEach(function (row) {
    var next = null;
    row.querySelectorAll('time[datetime]').forEach(function (el) {
      var d = new Date(el.getAttribute('datetime') + 'T00:00:00');
      if (d >= today && (!next || d < next.date)) next = { el: el, date: d };
    });
    if (!next) return;
    next.el.classList.add('is-next');
    var id = row.getAttribute('data-row');
    if (id) document.querySelectorAll('[data-clh-next="' + id + '"]').forEach(function (t) { t.textContent = fmt.format(next.date); });
  });
})();
